import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaymentMethod, PaymentMethods } from '@cargos/sprintpay-models';
import { Subject, takeUntil } from 'rxjs';
import { LogoPaymentMethodComponent } from 'src/app/shared/components';
import { RnplSloganComponent } from 'src/app/shared/components/rnpl-slogan/rnpl-slogan.component';
import { PaymentMethodsService } from 'src/app/shared/services';
import { CreditAmountComponent } from '../credit-amount/credit-amount.component';
import { CreditCardsModule } from '../method-credit-cards/credit-cards.module';
import { PaymentMethodsMaterialModule } from '../payment-methods-material-modules.module';
import { PaymentMethodItemService } from '../services/payment-methods.service';

@Component({
    selector: 'app-cargo-credit-internal',
    standalone: true,
    imports: [
        CommonModule,
        LogoPaymentMethodComponent,
        CreditAmountComponent,
        CreditCardsModule,
        PaymentMethodsMaterialModule,
        RouterModule,
        RnplSloganComponent,
    ],
    providers: [PaymentMethodItemService],
    templateUrl: './cargo-credit.component.html',
    styleUrls: ['./cargo-credit.component.scss'],
})
export class CargoCreditComponent implements OnInit, OnDestroy {
    public cargoCredit?: PaymentMethod;
    public creditPaymentMethod = '';
    public paymentMethodsEnum = PaymentMethods;
    private unsubscribe$: Subject<void> = new Subject<void>();

    @Input() containerSizeClass = 'normal';
    @Input() externalMessage = false;

    constructor(private paymentMethodsService: PaymentMethodsService) {}

    ngOnInit(): void {
        this.subscribeCargoSprintCredit();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeCargoSprintCredit(): void {
        this.creditPaymentMethod = PaymentMethods.SPRINTPAY_FLEX;
        this.paymentMethodsService
            .getPaymentMethodsByType(PaymentMethods.SPRINTPAY_FLEX)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (cargoCredit: PaymentMethod | undefined) => {
                    this.cargoCredit = cargoCredit;
                },
            });
    }
}
